import React from 'react';
import { compose, withHandlers } from 'recompose';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';
import { TextField } from '@material-ui/core';
import { BaseTextFieldProps } from '@material-ui/core/TextField';

import { FontIcon } from '../../FontIcon';

export interface SearchInputProps extends BaseTextFieldProps {
  placeholder?: string;
  variant: 'outlined';
}

interface SearchInputHandlers {
  resetField: (input: any) => void;
  handleChange: (val: string) => void;
}

interface SearchInputPrivateProps extends SearchInputProps, SearchInputHandlers {
  classes: any;
  input: any;
}

const styles = withStyles((): any => ({
  search: {
    position: 'relative',
    width: '100%',
    height: 50,
    minWidth: 100,
  },
  root: {
    height: 50,
    position: 'absolute',
    width: '100%',
  },
  inputTextFilter: {
    padding: '12px 0',
    paddingLeft: 10,
    paddingRight: 50,
    fontSize: '0.75rem',
  },
  buttonSearch: {
    position: 'absolute',
    right: -2,
    top: 5,
    width: 50,
    height: 50,
    textAlign: 'center',
    '&:hover': {
      cursor: 'pointer',
    },
    '&:active': {
      cursor: 'pointer',
    },
  },
  buttonIcon: {
    fontSize: 20,
    position: 'relative',
    top: 10,
  },
}));

const SearchInput: React.FunctionComponent<SearchInputPrivateProps> = (props) => {
  const { classes, resetField, handleChange, placeholder, className, ...rest } = props;

  const onBlurHandler = (e) => {
    const { input } = props;

    if (input.onBlur && typeof input.onBlur === 'function') {
      input.onBlur(e);
    }
  };

  const currentIcon = props.input.value.length > 0 ? 'close' : 'search';

  return (
    <div className={classes.search}>
      <TextField
        value={props.input.value}
        InputProps={{
          inputProps: { className: classes.inputTextFilter },
        }}
        placeholder={placeholder}
        className={classNames(classes.root, className)}
        onChange={(e) => handleChange(e.target.value)}
        onBlur={onBlurHandler}
        {...rest}
      />

      <div className={classNames(classes.buttonSearch)} onClick={resetField}>
        <FontIcon size={20} top={10} iconName={currentIcon} fromMui />
      </div>
    </div>
  );
};

const ComposedSearchInput = compose<SearchInputPrivateProps, SearchInputProps>(
  styles,
  withHandlers<SearchInputPrivateProps, SearchInputHandlers>({
    handleChange: ({ input }) => (val) => {
      input.onChange(val);
    },
    // Clean field on Click and reset Icon
    resetField: ({ input }) => () => {
      input.onChange('');
    },
  }),
)(SearchInput);

ComposedSearchInput.displayName = 'SearchInput';

export default ComposedSearchInput;
